import { render } from "./ChooseDataResearch.vue?vue&type=template&id=d4798bc2"
import script from "./ChooseDataResearch.vue?vue&type=script&lang=js"
export * from "./ChooseDataResearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__